import { createFileRoute, redirect, useNavigate, useSearch } from '@tanstack/react-router'
import { TeacherQuizzesPage } from '@unsw/features/quizzes'
import { getUserRole } from '@unsw/hooks'
import { useCallback } from 'react'

type TeacherQuizzesSearch = {
  edit?: string
}

export const Route = createFileRoute('/dashboard/teacher-quizzes')({
  beforeLoad: () => {
    const { isTeacher, isAdmin } = getUserRole()
    if (!isTeacher && !isAdmin) {
      throw redirect({ to: '/dashboard' })
    }
  },
  validateSearch: (search: Record<string, unknown>): TeacherQuizzesSearch => ({
    edit: search.edit ? String(search.edit) : undefined,
  }),
  component: TeacherQuizzesRoute,
})

function TeacherQuizzesRoute() {
  const navigate = useNavigate()
  const { edit } = useSearch({ from: '/dashboard/teacher-quizzes' })
  const editQuizId = edit ? Number(edit) : undefined

  const handleStartQuiz = useCallback(
    (quizId: number) => {
      navigate({
        to: '/dashboard/quiz-business',
        search: { quiz_id: quizId.toString() },
      })
    },
    [navigate],
  )

  const handleBrowseBusinessQuizzes = useCallback(() => {
    navigate({ to: '/dashboard/quiz-business' })
  }, [navigate])

  const handleClearEdit = useCallback(() => {
    navigate({ to: '/dashboard/teacher-quizzes', search: {}, replace: true })
  }, [navigate])

  return (
    <TeacherQuizzesPage
      onStartQuiz={handleStartQuiz}
      onBrowseBusinessQuizzes={handleBrowseBusinessQuizzes}
      initialEditQuizId={editQuizId}
      onClearEdit={handleClearEdit}
    />
  )
}
